import { giniView } from '../../../lib/giniView.cls';
var Const = /** @class */ (function () {
    function Const() {
    }
    // log tag
    Const.TAG = 'giniView';
    /*************************************************
    ////// store method hooks from here //////
    **************************************************/
    Const.RUN_REGISTER_STEP1 = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_REGISTER_STEP1';
    Const.RUN_REGISTER_STEP2 = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_REGISTER_STEP2';
    Const.RUN_REGISTER_STEP3 = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_REGISTER_STEP3';
    Const.RUN_REGISTER_STEP4 = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_REGISTER_STEP4';
    Const.RUN_CALL_REQUEST = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_CALL_REQUEST';
    Const.RUN_CONTACT_US = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_CONTACT_US';
    Const.RUN_GET_REGISTER_DATA = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_GET_REGISTER_DATA';
    Const.SET_REGISTER_DATA = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/SET_REGISTER_DATA';
    Const.GET_REGISTER_DATA = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/GET_REGISTER_DATA';
    Const.RUN_DIABETES_FORM = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_DIABETES_FORM';
    Const.RUN_CHECK_EMAIL = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_CHECK_EMAIL';
    Const.RUN_PAYU_REQUEST_INITIATE = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_PAYU_REQUEST_INITIATE';
    Const.SET_PAYU_REQUEST_INITIATE = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/SET_PAYU_REQUEST_INITIATE';
    Const.GET_PAYU_REQUEST_INITIATE = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/GET_PAYU_REQUEST_INITIATE';
    Const.RUN_GET_TIME_SLOTS = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_GET_TIME_SLOTS';
    Const.SET_TIME_SLOTS = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/SET_TIME_SLOTS';
    Const.GET_TIME_SLOTS = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/GET_TIME_SLOTS';
    Const.RUN_FIND_PROGRAM_FORM = giniView.STORE_MODULE_NAME + '/' + Const.TAG + '/RUN_FIND_PROGRAM_FORM';
    return Const;
}());
export { Const };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/giniView/provider/candle-history/lib/const.cls.ts
// module id = null
// module chunks = 